var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "position_detail",
    attrs: {
      "title": $t("c0pfat4", "岗位详情"),
      "width": "600px",
      "mask-closable": false,
      "footer-hide": ""
    },
    on: {
      "on-cancel": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.loading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "message"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v($t("cvxuf3", "名称:"))]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.detail.tagName))])]), _c('div', {
    staticClass: "message"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v($t("hfzsll5", "描述介绍:"))]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.detail.tagDescription))])]), _c('div', {
    staticClass: "message"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v($t("hk5mnr8", "可使用成员范围:"))]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm._tagTarget))])]), _c('div', {
    staticClass: "message"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v($t("jiv5as5", "包含成员:"))]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.detail.userNumber))])]), _c('div', {
    staticClass: "message"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v($t("jbozm45", "包含部门:"))]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.detail.orgNumber))])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };